export default __webpack_public_path__ + "static/media/arrow_down.a1c3a2e2.svg";